var map = {
	"./aaron.jpg": "b853",
	"./chris.jpg": "0f9d",
	"./daniel.jpg": "9a67",
	"./jumbo_video.mp4": "6f24",
	"./left.jpg": "d714",
	"./plat_extended_logo.png": "3ecf",
	"./plat_logo.png": "efcb",
	"./thomas.jpg": "1539"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";